import { h, Component } from 'preact';
import Store from 'store/store';
import * as actions from 'store/actions';

import { joinClasses } from 'utils/utils';

import Tiktok from 'components/bolt/icons/tiktok';
import Youtube from 'components/bolt/icons/youtube';
import Instagram from 'components/bolt/icons/instagram';
import Facebook from 'components/bolt/icons/facebook';
import Twitter from 'components/bolt/icons/twitter';

import s from 'components/shareIcons/shareIcons.sss';

export default class ShareIcons extends Component {

	constructor(props) {
		super(props);

		this.links = [
			{ id: 'tiktok', url: 'https://www.tiktok.com/@universalpics', icon: <Tiktok height="24" /> },
			{ id: 'youtube', url: 'https://www.youtube.com/UniversalPictures', icon: <Youtube height="24" /> },
			{ id: 'instagram', url: 'https://www.instagram.com/universalpictures/', icon: <Instagram height="24" /> },
			{ id: 'facebook', url: 'https://www.facebook.com/universalpictures/', icon: <Facebook height="24" /> },
			{ id: 'twitter', url: 'https://x.com/UniversalPics', icon: <Twitter height="24" /> }
		];
	}

	onClickHandler = (id, url) => {
		Store.emit(actions.CLICKED_FOLLOW, { type: this.props.id, id, url });
	};

	renderLink(link) {
		return <a href={link.url} target="_blank" rel="noopener noreferrer" onClick={this.onClickHandler.bind(this, link.id, link.url)}>{link.icon}</a>;
	}

	render(props) {
		return (
			<div class={joinClasses(s.wrapper, props.class)}>
				{this.links.map(link => this.renderLink(link))}
			</div>
		);
	}

}